import React, { useEffect, useState } from "react";
import "./BetaDisclaimerModal.less";

interface Props {}

export default function BetaDisclaimerModal({}: Props) {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const alreadySeen = localStorage.getItem("beta-disclaimer-accepted");
        if (!alreadySeen) {
            setIsOpen(true);
        }
    }, []);

    const handleClose = () => {
        localStorage.setItem("beta-disclaimer-accepted", "true");
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div className="beta-modal-overlay">
            <div className="beta-modal">
                <h2>Willkommen bei Blindtimer.com</h2>

                <p>
                    <strong>Blindtimer.com befindet sich aktuell in der offenen Beta.</strong>
                </p>
                <p>
                    Bitte beachte, dass sich noch Funktionen, Inhalte und Designs ändern können.
                    Der offizielle Release steht kurz bevor – sei gespannt!
                </p>
                <p>
                    In der Zwischenzeit empfehlen wir dir, einen Blick auf{" "}
                    <a href="https://powerpoker.shop" target="_blank" rel="noopener noreferrer">
                        powerpoker.shop
                    </a>{" "}
                    zu werfen, um dich bestens auf kommende Homegames vorzubereiten.
                </p>
                <button onClick={handleClose}>Verstanden</button>
            </div>
        </div>
    );
}
